import qs from "qs";
import useSWR from "swr";

import { api, createStyleDetailsUrl } from "@is/services/api";
import { Style } from "@is/types";
import { SearchSizesAndLengths } from "@is/types/style";

export const useStyleDetails = (
  styleId: string,
  searchSizesAndLengths: SearchSizesAndLengths,
  skipRequest?: boolean
) => {
  let queryParams = "";
  if (searchSizesAndLengths) {
    queryParams = `?${qs.stringify(
      {
        size: searchSizesAndLengths.sizes,
        length: searchSizesAndLengths.lengths,
      },
      { arrayFormat: "repeat" }
    )}`;
  }

  const url = createStyleDetailsUrl(styleId, queryParams);

  const { data, isLoading, error } = useSWR(
    !skipRequest && !!styleId && url,
    api.get
  );

  return {
    data: data as Style,
    isLoading,
    error,
  };
};
